export enum ShovelFloorControlEvaluationStatusEnum {
    Unknown = 0,
    InTolerance = 1,
    OutTolerance = 2
}


